import utils from "../../../src/js/utils";

var popups = {
	triggers: document.querySelectorAll(".map-journey-block [aria-controls]"),
	map: document.querySelector(".map-journey-block"),
	status: {
		open: function (link, popup) {
			link.classList.add("active");
			link.setAttribute("aria-label", "Chiudi il popup");
			popup.setAttribute("aria-hidden", "false");
			if (utils.screen.width < utils.breakpoint.sm) {
				document.body.style.overflow = "hidden";
				popups.map.classList.add("popup-open");
			}
		},
		close: function (link, popup) {
			link.classList.remove("active");
			link.setAttribute("aria-label", "Apri il popup");
			popup.setAttribute("aria-hidden", "true");
			if (utils.screen.width < utils.breakpoint.sm) {
				document.body.style.overflow = "";
				popups.map.classList.remove("popup-open");
			}
		},
		closeAll: function () {
			var openPopups = popups.map.querySelectorAll(
				'.popup[aria-hidden="false"]'
			);
			if (openPopups.length > 0) {
				utils.forEach(openPopups, function (index, popup) {
					var link = popups.map.querySelector(
						'[aria-controls="' + popup.id + '"]'
					);
					popups.status.close(link, popup);
				});
			}
		},
		toggle: function (link, popup) {
			link.addEventListener("click", function (e) {
				if (popup.getAttribute("aria-hidden") !== "false") {
					popups.status.open(link, popup);
				} else {
					popups.status.close(link, popup);
				}
			});
			popup.querySelector("button").addEventListener("click", function () {
				popups.status.close(link, popup);
			});
		},
	},
	set: function (link, popup) {
		if (!popup.hasAttribute("data-set")) {
			if (utils.screen.width >= utils.breakpoint.sm) {
				setTimeout(function () {
					var bound = link.getBoundingClientRect();
					var relativeTop =
						popups.map.getBoundingClientRect().bottom - utils.screen.height;
					if (relativeTop >= 0) {
						popup.style.top = bound.top + bound.height + "px";
					} else {
						popup.style.top = bound.top + bound.height - relativeTop + "px";
					}
					popup.style.left = bound.left + bound.width / 2 + "px";
				}, 50);
			}
			popups.status.toggle(link, popup);
			popup.setAttribute("data-set", "");
		}
	},
	init: function () {
		utils.forEach(popups.triggers, function (index, link) {
			var id = link.getAttribute("aria-controls");
			var popup = document.querySelector("#" + id);
			popups.set(link, popup);
		});
	},
};

var mapJourney = {
	el: document.querySelector(".map-journey-block"),
	detail: document.querySelector("#valdobbiadene"),
	attentionSeeker: false,
	animation: function () {
		var map = mapJourney.el.querySelector("#map-svg");
		var othersRegion = mapJourney.el.querySelector("#others-region");
		var veneto = mapJourney.el.querySelector("#veneto");
		var treviso = mapJourney.el.querySelector("#treviso");
		var valdobbiadene = mapJourney.el.querySelector("#valdobbiadene");
		var containerVeneto = mapJourney.el.querySelector("#veneto-proxy-2");
		var containerTreviso = mapJourney.el.querySelector("#treviso-proxy");
		var proxyVeneto = mapJourney.el.querySelector("#veneto-proxy");
		var proxyValdo = mapJourney.el.querySelector("#valdobbiadene-mask");
		var titles = {
			s01: mapJourney.el.querySelector("#map-title-00"),
			s02: mapJourney.el.querySelector("#map-title-01"),
			s03: mapJourney.el.querySelector("#map-title-02"),
			s04: mapJourney.el.querySelector("#map-title-03"),
		};
		var snapObj = {
			snapTo: "labelsDirectional",
			duration: { min: 0.15, max: 1 },
			delay: 0.1,
			ease: "power1.inOut", //TODO provare a cambiare ease  https://gsap.com/docs/v3/Eases
		};
		if (utils.screen.width < utils.breakpoint.sm) {
			snapObj = false;
		}
		var tl = gsap
			.timeline({
				scrollTrigger: {
					trigger: mapJourney.el,
					start: "top top",
					end: "bottom bottom",
					scrub: 1.6,
					snap: snapObj,
				},
			})
			.addLabel("step00")
			.to(map, { scale: 1.3, yPercent: 40, xPercent: 20, duration: 1 })
			.to(veneto, { clipPath: "polygon(0 0, 100% 0, 100% 0%, 0 0%)" })
			.to(othersRegion, { autoAlpha: 0.25 }, "<")
			.addLabel("step01", ">")
			.to(
				titles.s01,
				{ scale: 0.85, y: 30, x: 30, autoAlpha: 0, duration: 0.2 },
				"<"
			)
			.to(
				titles.s02,
				{ scale: 1, y: 0, x: 0, autoAlpha: 1, duration: 0.3 },
				"<0.1"
			)
			.to(map, { scale: 2.5, yPercent: 115, xPercent: 50, duration: 1 })
			.to(proxyVeneto, { clipPath: "polygon(0 0, 100% 0, 100% 0%, 0 0%)" })
			.addLabel("step02", ">")
			.to(othersRegion, { autoAlpha: 0 }, "<")
			.to(
				titles.s02,
				{ scale: 0.85, y: 30, x: 30, autoAlpha: 0, duration: 0.2 },
				"<"
			)
			.to(
				titles.s03,
				{ scale: 1, y: 0, x: 0, autoAlpha: 1, duration: 0.3 },
				"<0.1"
			)
			.to(treviso, { clipPath: "polygon(0 0, 100% 0, 100% 0%, 0 0%)" })
			.to(containerVeneto, { autoAlpha: 0.25 }, "<")
			.to(map, { scale: 16, yPercent: 1082, xPercent: 375, duration: 1 })
			.addLabel("step03", "<0.4")
			.to(containerVeneto, { autoAlpha: 0 }, "<")
			.to(containerTreviso, { autoAlpha: 0.25 }, "<")
			.to(
				titles.s03,
				{ scale: 0.85, y: 30, x: 30, autoAlpha: 0, duration: 0.2 },
				"<"
			)
			.to(
				titles.s04,
				{ scale: 1, y: 0, x: 0, autoAlpha: 1, duration: 0.3 },
				"<0.1"
			)
			.to(proxyValdo, {
				clipPath: "polygon(0 0, 100% 0, 100% 0%, 0 0%)",
				onStart: function () {
					popups.status.closeAll();
					popups.init();
					if (!mapJourney.attentionSeeker) {
						mapJourney.detail.classList.add("is-active");
						mapJourney.attentionSeeker = true;
					}
				},
				onReverseComplete: function () {
					popups.status.closeAll();
					if (mapJourney.attentionSeeker) {
						mapJourney.detail.classList.remove("is-active");
						mapJourney.attentionSeeker = false;
					}
				},
			})
			.to(
				valdobbiadene,
				{ clipPath: "polygon(0 0%, 100% 0%, 100% 100%, 0 100%)" },
				"<-0.005"
			)
			.addLabel("step04", ">")
			.to(containerTreviso, { autoAlpha: 0 }, "<-0.5");

		if (utils.screen.width < utils.breakpoint.sm) {
			tl.add(
				gsap.to(map, {
					scale: 34,
					yPercent: 2370,
					xPercent: 900,
					duration: 1,
				})
			);
			tl.add(
				gsap.to(map, {
					xPercent: 790,
					duration: 1,
				})
			);
		}
	},
	init: function () {
		if (mapJourney.el) {
			mapJourney.animation();
		}
	},
};

utils.domReady(function () {
	mapJourney.init();
});
